import { BASE_URL } from "../constants/Endpoints"
import axios from "axios";

export class PrivacyService {
    base(path) { return `${BASE_URL}/api-v1/privacy/${path}` }

    async send(contactId, appointmentDate, appointmentTime, note) {
        const payload = { contact_id: contactId };
        if (appointmentDate) payload.appointment_date = appointmentDate;
        if (appointmentTime) payload.appointment_time = appointmentTime;
        if (note) payload.note = note;
        return await axios.post(this.base('send'), payload, { withCredentials: true }).then(r => r.data);
    }

    async list() {
        return await axios.get(this.base('list'), { withCredentials: true }).then(r => r.data);
    }

    async listForContact(contactId) {
        return await axios.get(this.base('list'), { params: { contact_id: contactId }, withCredentials: true }).then(r => r.data);
    }

    async confirm(privacyId) {
        return await axios.post(this.base(`${privacyId}/confirm`), {}, { withCredentials: true }).then(r => r.data);
    }
}
